import type { FC, ReactNode } from 'react'

import { ButtonLink } from '@/components/generals/button'
import { MediaImage } from '@/components/generals/media-image'

export const HomeHero: FC = (): ReactNode => {
    return (
        <section id='hero' className='relative overflow-hidden'>
            <div className='mx-auto grid max-w-[1600px] lg:min-h-[calc(100svh-7.25rem)] lg:grid-cols-12'>
                <div className='relative order-2 flex flex-col justify-end px-6 pb-16 pt-10 sm:px-10 lg:order-1 lg:col-span-5 lg:pb-20 lg:pl-16 lg:pr-0 lg:pt-24'>
                    <p className='eyebrow text-muted-foreground motion-safe:animate-in motion-safe:fade-in motion-safe:duration-1000'>
                        Autumn-Winter 2026 Collection
                    </p>

                    <h1 className='mt-6 font-heading text-[clamp(4.25rem,11vw,9.5rem)] font-light leading-[0.85] tracking-[-0.015em] motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-6 motion-safe:duration-1000'>
                        Contre-
                        <br />
                        Jour
                    </h1>

                    <p className='mt-8 max-w-sm text-[15px] leading-relaxed text-muted-foreground'>
                        A collection drawn against the light. Sculpted shoulders, long lines and blacks that only reveal their texture when the sun is behind them.
                    </p>

                    <div className='mt-10 flex flex-wrap gap-3'>
                        <ButtonLink href='/collections/women'>
                            Discover Women
                        </ButtonLink>

                        <ButtonLink href='/collections/men' variant='outline'>
                            Discover Men
                        </ButtonLink>
                    </div>
                </div>

                <div className='relative order-1 h-[66svh] min-h-[440px] lg:order-2 lg:col-span-7 lg:h-auto'>
                    <div className='drift absolute inset-0 mix-blend-multiply'>
                        <MediaImage
                            preload
                            src='/images/home/hero.jpg'
                            alt='Model in a sculptural black gown photographed in silhouette against the light, her braids caught in motion'
                            sizes='(min-width: 1024px) 50vw, 100vw'
                            className='object-contain object-bottom'
                        />
                    </div>

                    <p className='eyebrow absolute bottom-8 right-8 hidden text-muted-foreground [writing-mode:vertical-rl] lg:block'>
                        Paris, Autumn-Winter 2026
                    </p>
                </div>
            </div>
        </section>
    )
}
